import React from 'react'
import DealWorkspace from '../../components/DealWorkspace/DealWorkspace'

export default function PropertyDetailView () {
  return <DealWorkspace />
}
